import { render, staticRenderFns } from "./AuthorizationBreadcrumb.vue?vue&type=template&id=66df3cac&scoped=true&"
import script from "./AuthorizationBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./AuthorizationBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationBreadcrumb.vue?vue&type=style&index=0&id=66df3cac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66df3cac",
  null
  
)

export default component.exports